import { useState, useEffect } from "react";
import { Form } from "antd";

import EmpleoServices from "./../../../../services/empresas/EmpleoServices"
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";


export const useEmpleo = (state) => {

    const [form] = Form.useForm();
    const navigate = useNavigate();

    const [empleos, setEmpleos] = useState(null);
    const [editEmpleo, setEditEmpleo] = useState(null);
    const [loading, setLoading] = useState(false);

    const onCreateEmpleo = async (empleo) => {
        setLoading(true);
        empleo.fecha_limite = dayjs(empleo.fecha_limite).format("YYYY-MM-DD");
        await EmpleoServices.createEmpleo(empleo);
        setLoading(false);
    }

    const getEmpleosMe = async () => {
        setLoading(true);
        const response = await EmpleoServices.getEmpleosMe();
        setLoading(false);
        setEmpleos(response.data);
        return response;
    }

    const onEditEmpleo = async (data) => {

        const record = {
            ...editEmpleo,
            ...data,
            fecha_limite: data?.fecha_limite ? dayjs(data?.fecha_limite).format("YYYY-MM-DD") : null,
        };

        setLoading(true);
        const response = await EmpleoServices.editEmpleo(record);
        setLoading(false);
        if (response.success) {
            navigate("/empresas/empleos")
        };
    }

    const onDeleteEmpleo = async (empleo) => {
        setLoading(true);
        const response = await EmpleoServices.deleteEmpleoMe(empleo.id_empleo);
        setLoading(false);
        if (response.success) {
            await getEmpleosMe();
        }
    } 
    
    const cambiarEstatusDePostulacion = async (data) => { 
        const response = await EmpleoServices.cambiarEstatusDePostulacion(data); 
        return response;
    }
    

    /* =====INICIO METODOS SOLO PARA EL MODULO DE POSTULACIONES DE EGRESADOS===== */
    const getEmpleosNoAplicadosByEgredado = async () => {
        setLoading(true);
        const response = await EmpleoServices.getEmpleosNoAplicadosByEgredado();
        setLoading(false);
        setEmpleos(response.data);
    }
    
    const postularEgresadoAEmpleo = async (empleo) => {
        setLoading(true);
        const response = await EmpleoServices.postularEgresadoAEmpleo(empleo?.id_empleo);
        setLoading(false);
        if (response.success) {
            await getEmpleosNoAplicadosByEgredado();
        }
    }
 
    const getPostulacionesByEmpleo = async (id_empleo) => {
        setLoading(true);
        const response = await EmpleoServices.getPostulacionesByEmpleo(id_empleo);
        setLoading(false);
        return response;

    }
     /* ===== FIN METODOS SOLO PARA EL MODULO DE POSTULACIONES DE EGRESADOS===== */

    useEffect(() => {
        // cargar empleos al formulario para editar 
        if (state && state.empleo) {
            const empleo = {
                ...state.empleo,
                fecha_limite: dayjs(state.empleo.fecha_limite),
            };
            setEditEmpleo(empleo);
            form.setFieldsValue(empleo);
        } else {
            form.resetFields();
        }
    }, [state?.empleo]);




    return {
        loading,
        empleos,
        form,
        onCreateEmpleo,
        onEditEmpleo,
        onDeleteEmpleo,
        getEmpleosMe,
        getEmpleosNoAplicadosByEgredado,
        postularEgresadoAEmpleo,
        getPostulacionesByEmpleo,
        cambiarEstatusDePostulacion
    };
}